import MaintenanceIcon from 'Img/maintenance.svg';
export const style = {
    main: {
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 4,
        textAlign: 'center'
    },
    title: {
        fontSize: 4
    },
    background: {
        backgroundImage: `url(${MaintenanceIcon})`,
        backgroundPosition: 'bottom',
        backgroundRepeat: 'no-repeat',
        width: '100%',
        height: '240px'
    },
    description: {
        color: 'neutral.800',
        mb: 3
    }
};
